<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 3 :</span> แผนงาน
        </div>

        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              1.แผนการดำเนินงาน (จัดทำในรูปเเบบ Project based management)
              <!--              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
            </div>
            <!--            <Button-->
            <!--                theme="6"-->
            <!--                :disabled="partOneEditMode || isOIC"-->
            <!--                @onClick="addNewPlan"-->
            <!--            >-->
            <!--              + เพิ่มแผนดำเนินงาน-->
            <!--            </Button>-->
          </div>

          <!--   PLAN HEADERS   -->
          <div class="py-5 overflow-x-auto mx-n6 px-6 scroll">
            <div class="d-flex justify-space-between gap-8 px-3 mb-3">
              <div class="flex" style="min-width: 42px; max-width: 42px">
                <!--                จัดการ-->
              </div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                กิจกรรม
              </div>
              <div class="flex" style="min-width: 61px; max-width: 61px">
                WF
              </div>
              <div
                v-for="(m, ind) in shortMonths"
                :key="ind"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div class="text-center">{{ m.month }}</div>
                <div class="text-center">{{ m.year }}</div>
              </div>
              <div class="flex" style="min-width: 43px; max-width: 43px">
                แผนผล
              </div>
              <div
                class="flex text-center"
                style="min-width: 43px; max-width: 43px"
              >
                %
              </div>
            </div>

            <!--   PLAN ITEMS   -->
            <div
              v-if="allPlansFormB && allPlansFormB.length > 0"
              class="d-flex flex-column gap-12"
            >
              <div
                v-for="(item, i) in allPlansFormB"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8"
                :class="{
                  'plan-active':
                    partOneEditMode && tempPlan && tempPlan.temp_index === i,
                }"
              >
                <div class="flex" style="min-width: 42px; max-width: 42px">
                  <!--                  <v-btn small icon @click="editPlan(i)">-->
                  <!--                    <Iconify-->
                  <!--                        icon="material-symbols:edit"-->
                  <!--                        color="var(&#45;&#45;theme-color-seven)"-->
                  <!--                    ></Iconify>-->
                  <!--                  </v-btn>-->
                </div>
                <div class="d-block">
                  <div
                    class="flex two-line"
                    style="min-width: 120px; max-width: 120px; max-height: 44px"
                  >
                    <tooltip-text :text="item.p1_activity_name" />
                  </div>
                </div>
                <!-- <div class="flex two-line" style="min-width: 120px; max-width: 120px; max-height: 44px">
                  {{ item.p1_activity_name }}
                </div> -->
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 61px; max-width: 61px; height: 54px"
                >
                  <v-divider vertical></v-divider>
                  <div
                    class="tiny-field tf-active"
                    style="min-width: 40px; max-width: 40px; height: 100%"
                  >
                    {{ item.p1_wf }}
                  </div>
                  <v-divider vertical></v-divider>
                </div>
                <div
                  v-for="(m, ind) in item.project_section_plan_month"
                  :key="ind"
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{ m.month_value ? m.month_value : "-" }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{ m.actual_month_value ? m.actual_month_value : "-" }}
                  </div>
                </div>

                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]?.month_value ||
                      "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]
                        ?.actual_month_value || "-"
                    }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[shortMonths.length - 1]
                        ?.month_value || "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      formatNumber(
                        parseFloat(
                          item.project_section_plan_month[currIndex]
                            ?.actual_month_value * 100
                        ) /
                          parseFloat(
                            item.project_section_plan_month[currIndex]
                              ?.month_value
                          ),
                        2
                      )
                    }}
                  </div>
                </div>
              </div>

              <!--   SUMMARY   -->
              <div class="plan-card">
                <div class="d-flex justify-space-between gap-8">
                  <div
                    class="flex"
                    style="min-width: 42px; max-width: 42px"
                  ></div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    แผนงานถ่วงน้ำหนัก
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div
                      class="tiny-field"
                      :class="{
                        'theme-color-four tf-error': totalWF() !== '1.00',
                      }"
                      style="min-width: 40px; max-width: 40px"
                    >
                      {{ totalWFFormB() }}
                    </div>
                    <v-divider vertical></v-divider>
                  </div>

                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlanFormB(ind) }}
                  </div>

                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlanFormB(currIndex) }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlanFormB(shortMonths.length - 1) }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div
                    class="flex"
                    style="min-width: 42px; max-width: 42px"
                  ></div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    ผลการดำเนินงาน
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal ? weightPlanFormB(ind, "actual_month_value") : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? weightPlanFormB(currIndex, "actual_month_value")
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              weightPlanFormB(currIndex, "actual_month_value") *
                                100
                            ) / parseFloat(weightPlanFormB(currIndex)),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>
                <v-divider class="mt-3"></v-divider>

                <div class="d-flex justify-space-between align-center gap-8 py-3" 
                 :class="{ 'bg-error': !validatePlanBudget() }">
                  <div
                    class="flex"
                    style="min-width: 42px; max-width: 42px"
                  ></div>
                  <div class="flex mt-0.5" style="min-width: 120px; max-width: 120px">
                    แผนการใช้จ่ายจริง 
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px;height: 25px;"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ total_plan_budget_rate[ind] }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ total_plan_budget_rate[currIndex] }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ total_plan_budget_rate[shortMonths.length - 1] }}
                  </div>
                </div>

                <v-divider class="mb-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div
                    class="flex"
                    style="min-width: 42px; max-width: 42px"
                  ></div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    การใช้จ่ายจริง
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ isFinal ? total_use_budget_rate[ind] : "-" }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ isFinal ? total_use_budget_rate[currIndex] : "-" }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(total_use_budget_rate[currIndex] * 100) /
                              parseFloat(total_plan_budget_rate[currIndex]),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
        </div>
      </div>

      <div v-if="partOneEditMode" id="part-one-edit" class="card-part">
        <div class="d-flex gap-16 mb-3">
          <div>
            <div class="black--text mb-3">กิจกรรม</div>

            <TextField
              theme="3"
              :value="tempPlan.p1_activity_name"
              @onChange="tempPlan.p1_actvity_name = $event"
            ></TextField>
          </div>
          <div>
            <div class="black--text mb-3">WF</div>

            <TextField
              theme="3"
              input-type="decimal"
              :value="tempPlan.p1_wf"
              :error="error_p1_wf"
              @onChange="tempPlan.p1_wf = $event"
            ></TextField>
          </div>
        </div>

        <div class="plan-field-form">
          <div v-for="(month, i) in shortMonths" :key="i">
            <div class="text-center mb-2">
              {{ month.month }} {{ month.year }}
            </div>
            <TextField
              theme="3"
              input-type="decimal"
              :error="
                tempPlan.project_section_plan_month[i]?.error ||
                tempPlan.project_section_plan_month[i]?.errorSkipInput
              "
              :value="tempPlan.project_section_plan_month[i]?.month_value"
              @onChange="
                tempPlan.project_section_plan_month[i].month_value = $event
              "
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="partOneEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="savePlan"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>

    <!--  FORM 2  -->
    <divcard>
      <div class="txt-head black--text d-flex justify-space-between">
        <div>
          2. งบประมาณ (รวมทุกแผนงานและกิจกรรม)
          <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
        </div>

        <v-btn
          icon
          :class="{ rotate180: expanded }"
          @click="expanded = !expanded"
        >
          <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="var(--theme-color-seven)"
          ></Iconify>
        </v-btn>
      </div>

      <div class="expandable" :class="{ 'expanded mt-3': expanded }">
        <div
          v-for="(item, i) in masterData.plan_master"
          :key="i"
          class="card-part"
          :class="{ 'pt-0': i === 0 }"
        >
          <div
            v-if="i === 0"
            class="d-flex black--text font-type-bold mb-5 gap-24"
          >
            <div style="width: 50%" class="pt-2">
              สรุปงบประมาณอุทยานวิทยาศาสตร์ภูมิภาค
            </div>
            <div style="width: 25%" class="text-center">RSP</div>
            <div style="width: 25%" class="text-center">สป.อว.</div>
          </div>

          <div v-if="item.id !== 0" class="mb-5">
            <div class="font-type-bold black--text mb-3">
              {{ i + 1 }}. {{ item.plan_name_th }} ({{ item.plan_name_en }})
            </div>

            <ul class="pl-12">
              <li
                v-for="(bud, ind) in item.form_ab_budget"
                :key="ind"
                class="mb-1"
              >
                <div class="d-flex gap-24">
                  <div style="width: 50%" class="pt-2">
                    {{ bud.budget_name }}
                  </div>
                  <div style="width: 25%" class="d-flex gap-12">
                    <TextField
                      theme="3"
                      :readonly="isOIC || isRSP"
                      input-type="decimal"
                      :value="bud.budget_amount_rsp"
                      isFormat
                    ></TextField>
                    <div class="pt-2">บาท</div>
                  </div>
                  <div style="width: 25%" class="d-flex gap-12">
                    <TextField
                      theme="3"
                      :readonly="isRSP"
                      input-type="decimal"
                      isFormat
                      :value="bud.budget_amount_ops"
                      @onChange="setBudgetOIC(bud, $event)"
                    ></TextField>
                    <div class="pt-2">บาท</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head"
              >3. ปัญหาและอุปสรรคจากการดำเนินงาน</span
            >
            <!--            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>-->
          </div>
          <TextArea
            theme="3"
            height="100"
            :value="form.problem"
            @onChange="setFormField('problem', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">4. แนวทางในการแก้ไขปัญหา</span>
            <!--            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>-->
          </div>
          <TextArea
            theme="3"
            height="100"
            :value="form.solution"
            @onChange="setFormField('solution', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import Button from "../../../components/input/Button";
import CheckBox from "../../../components/input/CheckBox";
import { eventBus, formatNumber } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import { format } from "date-fns";
import { th } from "date-fns/locale";

export default {
  name: "AFormPlan",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    CheckBox,
    Button,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      form: {},
      tempPlan: {},
      tempBudget: {},
      tempProgressPlan: {},
      budgetPlans: [],
      budget_plan_prototype: [],
      partOneEditMode: false,
      partTwoEditMode: false,
      expanded: false,
      allPlans: [],
      allPlansFormB: [],
      allEventsName: [
        "ส่งเสริมคุณภาพการออกแบบและพัฒนา",
        "พัฒนาระบบด้านเทคโนโลยีของหุ่นยนต์",
      ],
      shortMonths: [],
      plan_prototype: {
        p1_wf: "",
        project_section_plan_month: [],
      },
      progressPlan_prototype: {
        plan: [],
      },
      error_p1_wf: false,
      allProgressPlan: [
        {
          plan: [2, 3, 4, 5],
        },
        {
          plan: [5, 6],
        },
        {
          plan: [7, 8, 9, 10],
        },
      ],
      total_plan_budget_rate: [],
      total_use_budget_rate: [],
      planBudgets: {},
      currIndex: 0,
      fiscalYear: new Date().getFullYear() + 543,
    };
  },
  computed: {
    ...mapState({
      PlanForm: (state) => state.AForm.PlanForm,
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
      isRSP: (state) => state.Auth.User.user_type === "RSP",
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  created() {
    console.log("AFormPlan created");
    this.clearTempPlan();
    this.clearTempProgressPlan();
    if (this.masterData.form_a) {
      this.setData();
    }

    // set begin budget year month
    this.setupBudgetYearMonth();
    if (this.budgetPlans.length === 0) {
      this.budgetPlans = this.budget_plan_prototype;
    }
    this.currIndex = this.getCurrIndex();
    eventBus.$on("aFormPlan", () => {
      eventBus.$emit("aFormPlanSend", {
        ...this.form,
        project_section_plan_p1: this.allPlans.map((x) => ({
          ...x,
          percent: undefined,
        })),
        project_section_plan_p1_budget: this.budgetPlans,
        project_section_budget: this.budgetList,
        form_ab_budget: Object.values(this.planBudgets),
      });
    });
    eventBus.$on("aFormPlanSetData", () => this.setData());
  },
  methods: {
    setData() {
      this.budgetPlans =
        this.masterData.form_a.project_section_plan
          ?.project_section_plan_p1_budget || [];
      this.allPlans =
        this.masterData.form_a.project_section_plan?.project_plan_p1 || [];
      this.allPlansFormB = this.mapFormBPlanData(
        this.masterData.form_a.form_b || []
      );
      for (const x of this.allPlans) {
        x.percent = this.getLastProgress(x.project_section_plan_month);
      }
      if (
        this.masterData.form_a.form_ab_budget &&
        this.masterData.form_a.form_ab_budget.length > 0
      ) {
        let a = {};
        for (const x of this.masterData.form_a.form_ab_budget) {
          a[x.id] = {};
          a[x.id].id = x.id;
          a[x.id].budget_amount_ops = x.budget_amount_ops;
        }
        this.planBudgets = a;
      }
      this.form = this.masterData.form_a.form_ab_project_info;
      this.fiscalYear = this.masterData.form_a.fiscal_year;
    },
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    mapFormBPlanData(form_b_list) {
      let plan_data = [];
      let wf = 0;
      let plan_count = 0;
      form_b_list.forEach((form_b) => {
        if (
          form_b.project_section_plan.project_section_plan_p1_budget &&
          form_b.project_section_plan.project_section_plan_p1_budget.length > 0
        )
          plan_count++;
      });
      if (plan_count === 0) wf = 1.0;
      else wf = (1 / plan_count).toFixed(2);
      let total_amount = 0;
      let total_plan_budget_month = [];
      let total_use_budget_month = [];
      let month_length = 0;
      form_b_list.forEach((form_b, index) => {
        if (index === form_b_list.length - 1)
          wf = (1.0 - wf * (form_b_list.length - 1)).toFixed(2);
        total_amount =
          parseFloat(total_amount) + parseFloat(form_b.budget_amount);
        if (
          form_b.project_section_plan.project_section_plan_p1_budget &&
          form_b.project_section_plan.project_section_plan_p1_budget.length > 0
        ) {
          let plan = {
            p1_activity_name: form_b.plan.plan_master.plan_name_th,
            p1_wf: wf,
            project_section_plan_month:
              form_b.project_section_plan.project_section_plan_p1_budget,
            percent:
              form_b.project_section_plan.project_section_plan_p1_budget.slice(
                -1
              ).month_value,
          };
          month_length = plan.project_section_plan_month.length;
          console.log('plan.project_section_plan_month', plan.project_section_plan_month)
          for(let i = 0; i < month_length; i++) {
            if(!total_plan_budget_month[i]) total_plan_budget_month[i] = 0.00
            if(!total_use_budget_month[i]) total_use_budget_month[i] = 0.00
            total_plan_budget_month[i] = (parseFloat(total_plan_budget_month[i]) + parseFloat(plan.project_section_plan_month[i].plan_budget_sum)).toFixed(2)
            total_use_budget_month[i] = (parseFloat(total_use_budget_month[i]) + parseFloat(plan.project_section_plan_month[i].use_budget_sum)).toFixed(2)

          }
          console.log('total_use_budget_month1', total_use_budget_month)
          plan_data.push(plan)
        }
      });

      for (let ind = 0; ind < month_length; ind++) {
        if (
          parseFloat(total_use_budget_month[ind]) > 0 &&
          parseFloat(total_plan_budget_month[ind]) > 0
        )
          total_use_budget_month[ind] = (
            (parseFloat(total_use_budget_month[ind]) /
              parseFloat(total_plan_budget_month[ind])) *
            100
          ).toFixed(2);
        else total_use_budget_month[ind] = "0.00";
        total_plan_budget_month[ind] = (
          (parseFloat(total_plan_budget_month[ind]) /
            parseFloat(total_amount)) *
          100
        ).toFixed(2);
      }
      console.log("total_use_budget_month2", total_use_budget_month);
      this.total_plan_budget_rate = total_plan_budget_month;
      this.total_use_budget_rate = total_use_budget_month;
      return plan_data;
    },
    addNewPlan() {
      // clear temp index
      this.clearTempPlan();
      if (this.partOneEditMode) {
        this.$vuetify.goTo("#part-one-edit");
      } else {
        this.tempPlan.isNew = true;
        this.partOneEditMode = true;
      }
    },
    editPlan(i) {
      this.partOneEditMode = false;
      this.tempPlan = {
        ...this.removeVModel(this.allPlans[i]),
        temp_index: i,
      };
      this.partOneEditMode = true;
      this.$forceUpdate();
    },
    savePlan() {
      // complete 2 pos decimal format
      this.completeTwoPosDecimal();

      // validate WF
      if (!this.validateWF()) return;

      // validate conditions
      let before_value = 0;
      let error = [];
      for (const x of this.tempPlan.project_section_plan_month) {
        if (!isNaN(x.month_value) && parseFloat(x.month_value) < before_value) {
          x.error = true;
          error.push("Value must be greater than previous month value");
        } else {
          x.error = undefined;
          if (x.errorSkipInput) {
            error.push("Cannot skip the input between input values");
          }
        }
        before_value = parseFloat(x.month_value);
      }
      this.$forceUpdate();
      if (error.length > 0) {
        console.log(error);
        return;
      }

      let lastProgress = this.getLastProgress(
        this.tempPlan.project_section_plan_month
      );
      if (!this.tempPlan.isNew) {
        // EDIT
        this.allPlans[this.tempPlan.temp_index] = {
          ...this.tempPlan,
          percent: lastProgress,
          temp_index: undefined,
        };
      } else {
        // ADD
        this.allPlans.push({
          p1_activity_name: this.tempPlan.p1_actvity_name,
          p1_wf: this.tempPlan.p1_wf,
          project_section_plan_month: this.tempPlan.project_section_plan_month,
          percent: lastProgress,
        });
      }

      this.clearTempPlan();
      this.partOneEditMode = false;
    },
    clearTempPlan() {
      this.tempPlan = this.removeVModel(this.plan_prototype);
      this.error_p1_wf = false;
      this.$forceUpdate();
    },
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    getLastProgress(items) {
      items = this.removeVModel(items);
      if (items && typeof items === "object" && items.length > 0) {
        for (const x of items.reverse()) {
          if (!!x.month_value && x.month_value !== "-") {
            return x.month_value;
          }
        }
      }
      return "-";
    },
    completeTwoPosDecimal() {
      let i = 0;
      for (const x of this.tempPlan.project_section_plan_month) {
        x.errorSkipInput = undefined;
        if (!x.month_value || isNaN(x.month_value)) {
          x.month_value = null;
          if (i > 0) {
            let hasSomeProgressBefore = false;
            let hasSkipInput = false;
            for (let ind = 0; ind < i; ind++) {
              if (this.tempPlan.project_section_plan_month[ind].month_value) {
                hasSomeProgressBefore = true;
                for (
                  let lastInd =
                    this.tempPlan.project_section_plan_month.length - 1;
                  lastInd > i;
                  lastInd--
                ) {
                  if (
                    !!this.tempPlan.project_section_plan_month[lastInd]
                      .month_value
                  )
                    hasSkipInput = true;
                }
              }
            }

            if (hasSomeProgressBefore) x.month_value = "100.00";
            if (hasSkipInput) {
              x.month_value = null;
              x.errorSkipInput = true;
            }
          }
        } else {
          // no decimal case
          if (!x.month_value.toString().includes(".")) {
            x.month_value += ".00";
          } else {
            // decimal case
            let y = x.month_value.toString().split(".");
            if (!y[0] && y[0] != "0") {
              y[0] = "0";
            }
            if (!y[1] && y[1] != "0") {
              y[1] = "00";
            }
            // fill zero for 2 position decimal
            if (y.length > 1 && y[1].length === 1) {
              y[1] = y[1].toString() + "0"; // add 0 as string
            }
            // remove after 2 position decimal
            if (y.length > 1 && y[1].length > 2) {
              y[1] = y[1].substring(0, 2);
            }
            x.month_value = y[0] + "." + y[1];
            if (x.month_value === "0.00") x.month_value = null;
          }
        }
        i++;
      }
    },
    validateWF() {
      let error = [];
      let total = 0;
      let editCase =
        !!this.tempPlan.temp_index || this.tempPlan.temp_index === 0;

      // total is 1.00
      if (this.allPlans.length > 0) {
        if (this.allPlans.length === 1) {
          total = this.allPlans[0].p1_wf;
          if (editCase) total = 0;
        } else {
          if (editCase) {
            total = this.allPlans
              .filter((x, i) => i !== this.tempPlan.temp_index)
              .map((x) => x.p1_wf)
              .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
          } else {
            total = this.allPlans.reduce(
              (a, b) => parseFloat(a.p1_wf) + parseFloat(b.p1_wf),
              0
            );
          }
        }

        if (parseFloat(total) >= 1) {
          error.push("WF value cannot over exceed 1.00");
        }
      }

      if (!this.tempPlan.p1_wf || isNaN(this.tempPlan.p1_wf)) {
        error.push("WF value is not correct");
      } else {
        // no decimal case
        if (!this.tempPlan.p1_wf.toString().includes(".")) {
          this.tempPlan.p1_wf += ".00";
        } else {
          // decimal case
          let y = this.tempPlan.p1_wf.toString().split(".");
          if (!y[0] && y[0] != "0") {
            y[0] = "0";
          }
          if (!y[1] && y[1] != "0") {
            y[1] = "00";
          }
          // fill zero for 2 position decimal
          if (y.length > 1 && y[1].length === 1) {
            y[1] = y[1].toString() + "0"; // add 0 as string
          }
          // remove after 2 position decimal
          if (y.length > 1 && y[1].length > 2) {
            y[1] = y[1].substring(0, 2);
          }
          this.tempPlan.p1_wf = y[0] + "." + y[1];
          if (this.tempPlan.p1_wf === "0.00") {
            error.push("WF value is not correct");
          }
        }
        if (this.tempPlan.p1_wf > 1) {
          error.push("WF value must less or equal 1.00");
        }
      }

      if (parseFloat(total) + parseFloat(this.tempPlan.p1_wf) > 1) {
        error.push("WF total value must equal 1.00");
      }

      if (error.length > 0) {
        console.log(error);
        this.error_p1_wf = true;
      } else {
        this.error_p1_wf = false;
      }
      this.$forceUpdate();

      return !this.error_p1_wf;
    },
    totalWF() {
      if (!this.allPlans || this.allPlans.length === 0) return "-";
      let total = this.allPlans
        .map((x) => x.p1_wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightPlan(index) {
      let total = [];
      for (const x of this.allPlans) {
        let result = parseFloat(
          x.project_section_plan_month[index].month_value * x.p1_wf
        );
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    getCurrIndex() {
      let ind = 0;
      for (const x of this.allPlansFormB) {
        let i = 0;
        for (const y of x.project_section_plan_month) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean") return correctIndex;
          i++;
        }
        ind++;
      }
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      let currentMonth = today.getMonth();
      let thisMonth = new Date(item.year_month).getMonth();

      let isCorrectCase = thisMonth === currentMonth;

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;

      return isCorrectCase;
    },
    totalWFFormB() {
      if (!this.allPlansFormB || this.allPlansFormB.length === 0) return "-";
      let total = this.allPlansFormB
        .map((x) => x.p1_wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightPlanFormB(index, field = "month_value") {
      let total = [];
      for (const x of this.allPlansFormB) {
        let result = parseFloat(
          x.project_section_plan_month[index][field] * x.p1_wf
        );
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    addNewBudget() {
      // if (this.partTwoEditMode) {
      //   // clear temp index
      //   this.clearTempPlan()
      //
      //   this.$vuetify.goTo('#part-one-edit')
      // } else {
      //   this.tempPlan.isNew = true
      this.partTwoEditMode = true;
      // }
    },
    saveBudget() {},
    addNewPlanDetail() {
      this.clearTempProgressPlan();
      this.partThreeEditMode = true;
    },
    saveProgressPlan() {
      let error = [];
      if (this.tempProgressPlan.plan.length === 0) {
        error.push("Select at least 1 month for planning");
        return;
      }
      if (this.tempProgressPlan.temp_index !== undefined) {
        // EDIT
        this.allProgressPlan[this.tempProgressPlan.temp_index] = {
          ...this.tempProgressPlan,
          temp_index: undefined,
        };
      } else {
        // ADD
        this.allProgressPlan.push(this.tempProgressPlan);
      }
      this.clearTempProgressPlan();
      this.partThreeEditMode = false;
    },
    progressPlanCheck(key) {
      if (this.tempProgressPlan.plan.includes(key)) {
        this.tempProgressPlan.plan = this.tempProgressPlan.plan.filter(
          (x) => x !== key
        );
      } else {
        this.tempProgressPlan.plan.push(key);
      }
    },
    clearTempProgressPlan() {
      this.tempProgressPlan = this.removeVModel(this.progressPlan_prototype);
      this.$forceUpdate();
    },
    editProgressPlan(index) {
      this.partThreeEditMode = false;
      this.tempProgressPlan = {
        ...this.removeVModel(this.allProgressPlan[index]),
        temp_index: index,
      };
      this.partThreeEditMode = true;
      this.$forceUpdate();
    },
    setBudgetOIC(item, val) {
      this.$set(item, 'budget_amount_ops', val); 
      if (!this.planBudgets[item.id]) this.planBudgets[item.id] = {};
      this.planBudgets[item.id].id = item.id;
      this.planBudgets[item.id].budget_amount_ops = val;
    },
    setupBudgetYearMonth() {
      let ym = new Date((this.fiscalYear - 544).toString() + "-10");
      for (let i = 0; i < 12; i++) {
        this.shortMonths.push({
          key: i + 1,
          month: format(ym, "MMM", { locale: th }),
          year: (parseInt(ym.toISOString().substr(0, 7).split("-")[0]) + 543)
            .toString()
            .slice(2),
        });
        this.plan_prototype.project_section_plan_month.push({
          year_month: ym.toISOString().substr(0, 7),
          month_value: "",
        });
        this.budget_plan_prototype.push({
          year_month: ym.toISOString().substr(0, 7),
          month_value: "",
          plan_budget: "",
          plan_budget_rate: "",
        });
        ym = new Date(ym.setMonth(ym.getMonth() + 1));
      }
    },
    validatePlanBudget() {
      let isCorrect = true;
      const Data =  this.masterData?.form_a?.form_b[0]?.project_section_plan?.project_section_plan_p1_budget
      // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
     
      if (!Data || Data?.length === 0) return false;
   
      if (
        Data?.filter((x) => x.plan_budget !== "")
          .length === 0 ||
        Data?.filter((x) => x.plan_budget != 0)
          .length === 0 ||
        Data?.filter((x) => x.plan_budget != "0.00")
          .length === 0
      ) {
        isCorrect = false;
      }
     
      // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
      if (
        Data
          ?.map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
          .reduce((a, b) => a + b, 0) !==
      this.masterData?.form_a?.form_b[0]?.form_ab_budget
          ?.map((x) => parseFloat(x.budget_amount_rsp))
          .reduce((a, b) => a + b, 0)
      ) {
    
        isCorrect = false;
      }
      return isCorrect;
    },
  },
};
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #fafafa;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: "Tahoma", sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
</style>
